import React, { useState } from 'react';
import * as Comp from './PuckComps';

import { TwAlert } from '@ui-component-library';
import { migrate } from "@measured/puck";
import { config } from './EditorConfig';
import { startRouteTracking, endRouteTracking, initUnloadTracking } from '@services/route-tracking';
import { Text } from '@ui-component-library';

class PuckPageView extends React.Component {
    constructor(props) {
        super(props);
        const migratedData = migrate(Window.react_data, config)
        this.state = {
            alert: Window.react_data.alert,
            contentData: migratedData
        }
    }

    componentDidMount() {
        const routeName = Window.react_data?.title || 'puck_page';
        startRouteTracking(routeName);
        initUnloadTracking();
    }

    componentWillUnmount() {
        endRouteTracking();
    }

    render() {
        return (
            <>
                {/* We show this alert if the page is not live but an Admin is viewing the page for review */}
                {this.state.alert ? (
                    <TwAlert
                        className="text-center rounded-[0px] px-8 py-2 gap-2 bg-danger-500 flex flex-col items-center justify-center lg:flex-row lg:gap-4 lg:px-12 lg:py-6"
                        icon="WarningFilled"
                        visible={!!this.state.alert}
                        allowClose
                        onClose={() => this.setState({ alert: false })}
                    >
                        <Text variant="text-xl/leading-none/medium" className="white-50 font-bold">Warning!</Text>
                        <Text variant="text-xl/leading-none/medium" className="mb-0 text-white-50">{this.state.alert}</Text>
                    </TwAlert>
                ) : null}

                {this.state.contentData.content.map((component, index) => {
                    // Fetch the correct component to render
                    let Component = Comp[component.type];

                    return <Component key={index} {...component.props} />
                })}

            </>
        );
    }
}

export default PuckPageView;
